import { motion, useMotionValue, useSpring } from "framer-motion";
import React, { useRef } from "react";

interface MouseParallaxProps {
    children: React.ReactNode;
    strength?: number;
    className?: string;
}

export default function MouseParallax({ children, strength = 20, className = "" }: MouseParallaxProps) {
    const ref = useRef<HTMLDivElement>(null);

    const x = useMotionValue(0);
    const y = useMotionValue(0);

    const springConfig = { damping: 15, stiffness: 150 };
    const springX = useSpring(x, springConfig);
    const springY = useSpring(y, springConfig);

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        const { clientX, clientY } = e;
        const { innerWidth, innerHeight } = window;

        const moveX = (clientX - innerWidth / 2) / (innerWidth / 2);
        const moveY = (clientY - innerHeight / 2) / (innerHeight / 2);

        x.set(moveX * strength);
        y.set(moveY * strength);
    };

    const handleMouseLeave = () => {
        x.set(0);
        y.set(0);
    };

    return (
        <motion.div
            ref={ref}
            className={className}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            style={{
                x: springX,
                y: springY,
            }}
        >
            {children}
        </motion.div>
    );
}
